import { HubBrief } from '../models';

export class HubContextListLoad {
  public static readonly type = '[HubContext] List Load';
}

export class HubContextSelectItem {
  public static readonly type = '[HubContext] Select Item';
  constructor(public payload: HubBrief) {}
}

export class HubContextUpdateSelectedItem {
  public static readonly type = '[HubContext] Update Selected Item';
}

export class HubContextInitialState {
  public static readonly type = '[HubContext] Set Initial State';
}

export class HubContextRecalculateTimezone {
  public static readonly type = '[HubContext] Recalculate Timezone';
}
